/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { TableHead } from './gridComponents/tableHead';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

export default function DisplayInvoiceRegister() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [displayedRows, setDisplayedRows] = React.useState(resultList ?? []);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const activepgmCode = window.location.pathname.split('/')[2];
  const {
    isLoading,
    displayObj: {
      // rebateProgramValue,
      // rebateProgramList,
      quarterValue,
      formerRetains,
      invoiceHandle,
      invoiceOption,
      rebateProgrameName,
    },
  } = useSelector((state) => state?.sharedState?.InvoiceRegisterReducer);
  const findDisplayObj = useSelector((state) =>
    state?.sharedState?.InvoiceRegisterReducer?.displayHeaderObj?.find(
      (obj) => {
        return obj[activepgmCode];
      }
    )
  );
  const displayObj = findDisplayObj?.[activepgmCode]?.displayObj;
  const find_invoiceResult = useSelector((state) =>
    state?.sharedState?.InvoiceRegisterReducer?.invoiceResult?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const invoiceResult = find_invoiceResult?.[activepgmCode];
  const find_invoiceResultUnchecked = useSelector((state) =>
    state?.sharedState?.InvoiceRegisterReducer?.invoiceResultUnchecked?.find(
      (obj) => {
        return obj[activepgmCode];
      }
    )
  );
  const invoiceResultUnchecked = find_invoiceResultUnchecked?.[activepgmCode];

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = displayObj?.rebateProgrameName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  // Businness logic
  React.useEffect(() => {
    let updatedInvoiceResult = invoiceResult || [];
    let updatedInvoiceResultUnchecked = invoiceResultUnchecked || [];

    updatedInvoiceResult = updatedInvoiceResult.map((item) => {
      let invoiceHandlingCd = null;
      if (item.invoiceHandlingCd === 'M') {
        invoiceHandlingCd = 'Mail';
      }
      if (item.invoiceHandlingCd === 'R') {
        invoiceHandlingCd = 'Retain';
      }
      if (item.invoiceHandlingCd === 'F') {
        invoiceHandlingCd = 'Forgive';
      }
      const totalBalanceCal =
        item.totCurrQtrAmt +
        item.totUnitChangesAmt +
        item.totInformationalAmt +
        item.interestDue;
      return {
        ...item,
        electDist:
          item.cdCreateDt === null && item.invoiceUploadedDt === null ? 0 : 1,
        totalBal: parseFloat(totalBalanceCal).toFixed(2),
        invoiceHandlingCd: invoiceHandlingCd,
        qtr: `${item.qtr.slice(4)}Q${item.qtr.slice(0, 4)}`,
        invoiceFreezeDt: item.invoiceFreezeDt
          ? moment(new Date(item.invoiceFreezeDt)).format('MM/DD/YYYY')
          : '',
        interestDue:
          item.interestDue === null
            ? '0.00'
            : parseFloat(item.interestDue?.toFixed(2)),
        totCurrQtrAmt:
          item.totCurrQtrAmt === 0
            ? '0.00'
            : parseFloat(item.totCurrQtrAmt?.toFixed(2)),
        totUnitChangesAmt:
          item.totUnitChangesAmt === 0
            ? '0.00'
            : parseFloat(item.totUnitChangesAmt?.toFixed(2)),
        totInformationalAmt:
          item.totInformationalAmt === 0
            ? '0.00'
            : parseFloat(item.totInformationalAmt?.toFixed(2)),
      };
    });
    updatedInvoiceResultUnchecked = updatedInvoiceResultUnchecked.map(
      (item) => {
        let invoiceHandlingCd = null;
        if (item.invoiceHandlingCd === 'M') {
          invoiceHandlingCd = 'Mail';
        }
        if (item.invoiceHandlingCd === 'R') {
          invoiceHandlingCd = 'Retain';
        }
        if (item.invoiceHandleDisplay === 'F') {
          invoiceHandlingCd = 'Forgive';
        }
        return {
          ...item,
          electDist:
            item.cdCreateDt === null && item.invoiceUploadedDt === null ? 0 : 1,
          totalBal:
            item.totCurrQtrAmt +
            item.totUnitChangesAmt +
            item.totInformationalAmt +
            item.interestDue,
          invoiceHandlingCd: invoiceHandlingCd,
          qtr: `${item.qtr.slice(4)}Q${item.qtr.slice(0, 4)}`,
          invoiceFreezeDt: item.invoiceFreezeDt
            ? moment(new Date(item.invoiceFreezeDt)).format('MM/DD/YYYY')
            : '',
          interestDue:
            item.interestDue === null
              ? '0.00'
              : parseFloat(item.interestDue?.toFixed(2)),
          totCurrQtrAmt:
            item.totCurrQtrAmt === 0
              ? '0.00'
              : parseFloat(item.totCurrQtrAmt?.toFixed(2)),
          totUnitChangesAmt:
            item.totUnitChangesAmt === 0
              ? '0.00'
              : parseFloat(item.totUnitChangesAmt?.toFixed(2)),
          totInformationalAmt:
            item.totInformationalAmt === 0
              ? '0.00'
              : parseFloat(item.totInformationalAmt?.toFixed(2)),
        };
      }
    );
    setResultList(
      displayObj?.formerRetains
        ? updatedInvoiceResult
        : updatedInvoiceResultUnchecked
    );
  }, [invoiceResult, invoiceResultUnchecked]);

  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // //Function to add the rows
  const sum = (property) => {
    // const displayedRows = resultList;
    const displayedRows = filterApply ? filteredRows : resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };

  // //columns to show total
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        invoiceNum: 'Total :',
        totCurrQtrAmt: sum('totCurrQtrAmt'),
        totUnitChangesAmt: sum('totUnitChangesAmt'),
        totInformationalAmt: sum('totInformationalAmt'),
        interestDue: sum('interestDue')?.toFixed(2),
        totalBal: sum('totalBal'),
        // electDist: null,
      });
    }
    return result;
  };

  // //To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [resultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  // //PDF header
  const firstInfo = `Quarter : ${displayObj?.quarterValue}`;
  const secondInfo = `Invoice Option : ${
    displayObj?.invoiceOption === '1'
      ? 'Only Frozen'
      : displayObj?.invoiceOption === '2'
      ? 'Only Unfrozen'
      : displayObj?.invoiceOption === '3'
      ? 'All'
      : ''
  }`;
  const fourthInfo = displayObj?.formerRetains
    ? 'Former Retain : Include'
    : 'Former Retain : Exclude';
  const thirdInfo = `${rebateProgramNameValue}`;
  const fifthInfo = `Invoice Handling Code : None : ${
    displayObj?.invoiceHandle?.None ? 'Include' : 'Exclude'
  }, Forgiven: ${displayObj?.invoiceHandle?.Forgiven ? 'Include' : 'Exclude'}, 
  Mailed: ${
    displayObj?.invoiceHandle?.Mailed ? 'Include' : 'Exclude'
  }, Retained: ${displayObj?.invoiceHandle?.Retained ? 'Include' : 'Exclude'}`;

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={isLoading} />
        <CustomSeparator
          parent1="Summary Reports"
          parent2={`Display-Invoice-Register [${activepgmCode}]`}
        />

        <div className="tBillPanel custom-check tabs-container bottom-pinned-bold">
          {!fullScreenView && (
            <div className="form-wrapper p-0 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <div className="sub-radio no-margin">
                  <div className="row mb-2">
                    <div className="col-6">
                      <TextField
                        label="Rebate Program : "
                        id="Rebate Program :"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={rebateProgramNameValue}
                        name="RebateProgram"
                        disabled
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <TextField
                        label="Include Frozen Invoices :"
                        id="Include Frozen Invoices :"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="FrozenInvoice"
                        value={
                          displayObj?.invoiceOption === '1'
                            ? 'Only Frozen'
                            : displayObj?.invoiceOption === '2'
                            ? 'Only Unfrozen'
                            : displayObj?.invoiceOption === '3'
                            ? 'All'
                            : ''
                        }
                        disabled
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <TextField
                        label="Quarter :"
                        id="Quarter :"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="Quarter"
                        disabled
                        value={displayObj?.quarterValue}
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <TextField
                        value={
                          displayObj?.formerRetains ? 'Include' : 'Exclude'
                        }
                        label="Former Retains :"
                        id="Former Retains :"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="FormerRetains"
                        disabled
                      />
                    </div>
                    <fieldset className="custom-fieldset col-12">
                      <legend className="same-font-family">
                        Invoice Handling Codes
                      </legend>
                      <div className="row mb-2">
                        <div className="col-6">
                          <TextField
                            label="None :"
                            id="None :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="None"
                            disabled
                            value={
                              displayObj?.invoiceHandle?.None
                                ? 'Include'
                                : 'Exclude'
                            }
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <TextField
                            label="Forgiven :"
                            id="Forgiven :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="Forgiven"
                            disabled
                            value={
                              displayObj?.invoiceHandle?.Forgiven
                                ? 'Include'
                                : 'Exclude'
                            }
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <TextField
                            label="Mailed :"
                            id="Mailed :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="Mailed"
                            disabled
                            value={
                              displayObj?.invoiceHandle?.Mailed
                                ? 'Include'
                                : 'Exclude'
                            }
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <TextField
                            label="Retained :"
                            id="Retained :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="Retained"
                            disabled
                            value={
                              displayObj?.invoiceHandle?.Retained
                                ? 'Include'
                                : 'Exclude'
                            }
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          )}
          <TableGridWithFeatures
            rowData={resultList?.map((item) => {
              return {
                ...item,
                totCurrQtrAmt: item.totCurrQtrAmt ? item.totCurrQtrAmt : '0.00',
                totUnitChangesAmt: item.totUnitChangesAmt
                  ? item.totUnitChangesAmt
                  : '0.00',
                totInformationalAmt: item.totInformationalAmt
                  ? item.totInformationalAmt
                  : '0.00',
                totalBal: item.totalBal
                  ? parseFloat(item.totalBal).toFixed(2)
                  : '0.00',
                interestDue: item.interestDue ? item.interestDue : '0.00',
              };
            })}
            columnDefs={TableHead}
            rowMultiSelectWithClick
            data-testid="onEditingStopped"
            enterMovesDown
            showResetFilter={false}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            hideTotalCount={false}
            noGlobalSort
            exportFile
            fileName="InvoiceRegister "
            reportName="Invoice Register Report"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
            pinnedBottomRowData={pinnedBottomRowData}
            isScrollOn
            // defaultColWidth={250}
            onFilterData={onFilterChanged}
            frameworkComponents={{
              CheckBoxSelectedForRCellRender: (cellInfo) => {
                if (cellInfo.data.isBottomRow) {
                  return null;
                }
                return (
                  <div
                    style={{ marginTop: 10 }}
                    className="ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-cell-value ag-cell-focus"
                  >
                    <div className="tbl-checkbox frr-checkbox-no-label">
                      <FormControlLabel
                        data-testid="checkBox"
                        label="checkbox"
                        control={<Checkbox color="primary" />}
                        disabled={parseInt(cellInfo.value) !== 1}
                        checked={
                          !(
                            cellInfo.data.cdCreateDt === null &&
                            cellInfo.data.invoiceUploadedDt === null
                          )
                        }
                      />
                    </div>
                  </div>
                );
              },
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo, fifthInfo }}
            getFilterApply={getFilterApply}
          />
        </div>
      </div>
    </div>
  );
}
